import { render, staticRenderFns } from "./ModalGlobal.vue?vue&type=template&id=337967ce&scoped=true&"
import script from "./ModalGlobal.vue?vue&type=script&lang=js&"
export * from "./ModalGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337967ce",
  null
  
)

export default component.exports